import { render } from "./DashedChart.vue?vue&type=template&id=632cbb1e&ts=true"
import script from "./DashedChart.vue?vue&type=script&lang=ts"
export * from "./DashedChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__